import { defineSlotRecipe } from '@chakra-ui/react';

export const basicButtonSlotRecipe = defineSlotRecipe({

	slots: ['button', 'icon', 'label'],

	base: {
		button: {
			boxShadow: 'sm',
			bg: 'secondary',
			color: 'white',
			h: '10',
			borderRadius: 'md',
			blur: 'md',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			gap: '1.5',
			w: 'full',
			_hover: { bg: 'secondary._hover' },
			_active: { bg: 'secondary._active !important' },
		},
		icon: {
			display: 'flex',
		},
		label: {
			fontWeight: 'semibold',
			fontSize: 'sm',
		},
	},

	variants: {
		type: {
			success: {
				button: {
					color: 'white',
					bg: 'success',
					_hover: {
						bg: 'success._hover',
					},
					_active: {
						bg: 'success._active !important'
					}
				}
			},
			warning: {
				button: {
					color: 'white',
					bg: 'warning',
					_hover: {
						bg: 'warning._hover',
					},
					_active: {
						bg: 'warning._active !important'
					}
				}
			},
			primary: {
				button: {
					color: 'white',
					bg: 'primary',
					_hover: {
						bg: 'primary._hover',
					},
					_active: {
						bg: 'primary._active !important'
					}
				}
			},
			secondary: {
				button: {
					color: 'white',
					bg: 'secondary',
					_hover: {
						bg: 'secondary._hover',
					},
					_active: {
						bg: 'secondary._active !important'
					}
				}
			},
			error: {
				button: {
					color: 'white',
					bg: 'error',
					_hover: {
						bg: 'error._hover',
					},
					_active: {
						bg: 'error._active !important'
					}
				}
			},
			disabled: {
				button: {
					color: 'disabled.label',
					bg: 'disabled',
				}
			}
		},

		size: {
			full: {
				button: {
					w: 'full',
					h: 10
				},
			},
			xs: {
				button: {
					h: 6,
					w: 32
				},
			},
			sm: {
				button: {
					h: 8,
					w: 32
				},
			},
			md: {
				button: {
					h: 9,
					w: 32
				},
			},
			lg: {
				button: {
					h: 10,
					w: 32
				},
			},
			xl: {
				button: {
					h: 11,
					w: 32
				},
			},
		},

		mode: {
			iconOnly: {
				icon: {
					w: '8',
					h: '8',
				},
			}
		}
	},

	defaultVariants: {
		size: 'full'
	}
});